import {
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet
} from '@angular/router';

import {
  filter
} from 'rxjs';

import {
  AuthService
} from '../../core/auth.service';

import {
  ApiService
} from '../../core/api.service';

import {
  RestaurantContextService
} from '../../core/restaurant-context.service';

import {
  Permission,
  RestaurantRole
} from '../../core/permissions';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl:
    './dashboard.component.html',
  styleUrl:
    './dashboard.component.css'
})
export class DashboardComponent
  implements OnInit {

  user: any = null;

  loadingPermissions = true;
  permissionsLoaded = false;

  tablesMenuOpen = false;
  sidebarCollapsed = false;

  constructor(
    private auth: AuthService,
    private api: ApiService,
    private restaurantContext:
      RestaurantContextService,
    private router: Router
  ) {}

  ngOnInit(): void {

  /*
   * Em telas pequenas o menu
   * começa automaticamente recolhido.
   */
  // if (
  //   window.innerWidth <= 680
  // ) {

  //   this.sidebarCollapsed = true;

  // } else {

    this.sidebarCollapsed =
      localStorage.getItem(
        'admin_sidebar_collapsed'
      ) === 'true';

//  }



    this.user =
      this.auth.getUser();

    this.loadRestaurantContext();

    /*
     * Abre o submenu caso a rota atual
     * seja uma das telas de mesas.
     */
    this.updateTablesMenuState();

    /*
     * Observa mudanças de rota.
     */
    this.router.events
      .pipe(
        filter(
          (
            event
          ): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe(() => {
        this.updateTablesMenuState();
      });
  }

  /**
   * Abre ou fecha o submenu de mesas.
   */
  toggleTablesMenu123(): void {
    this.tablesMenuOpen =
      !this.tablesMenuOpen;
  }

// toggleTablesMenu(): void {

//   /*
//    * Se estiver recolhido,
//    * expande primeiro.
//    */
//   if (
//     this.sidebarCollapsed
//   ) {
//     this.sidebarCollapsed =
//       false;

//     localStorage.setItem(
//       'admin_sidebar_collapsed',
//       'false'
//     );

//     this.tablesMenuOpen =
//       true;

//     return;
//   }

//   this.tablesMenuOpen =
//     !this.tablesMenuOpen;
// }



toggleTablesMenu(): void {

  if (
    this.sidebarCollapsed
  ) {
    this.sidebarCollapsed =
      false;

    localStorage.setItem(
      'admin_sidebar_collapsed',
      'false'
    );

    this.tablesMenuOpen =
      true;

    return;
  }

  this.tablesMenuOpen =
    !this.tablesMenuOpen;
}


  toggleSidebar(): void {

  this.sidebarCollapsed =
    !this.sidebarCollapsed;

  localStorage.setItem(
    'admin_sidebar_collapsed',
    String(
      this.sidebarCollapsed
    )
  );

  /*
   * Se recolher, fecha submenu.
   */
  if (
    this.sidebarCollapsed
  ) {
    this.tablesMenuOpen =
      false;
  }
}

  /**
   * Informa se alguma rota de mesas
   * está ativa.
   */
  get isTablesRouteActive(): boolean {
    return (
      this.router.url.startsWith(
        '/admin/mesas'
      ) ||
      this.router.url.startsWith(
        '/admin/gerenciar-mesas'
      )
    );
  }

  /**
   * Mantém o submenu aberto quando
   * uma rota de mesas estiver ativa.
   */
  // private updateTablesMenuState(): void {
  //   if (this.isTablesRouteActive) {
  //     this.tablesMenuOpen = true;
  //   }
  // }


  private updateTablesMenuState(): void {

  /*
   * MOBILE
   *
   * No celular não abrimos automaticamente
   * o submenu só porque estamos em uma rota
   * de mesas.
   */
  if (window.innerWidth <= 680) {
    this.tablesMenuOpen = false;
    return;
  }

  /*
   * DESKTOP
   *
   * Mantém o comportamento atual:
   * se estiver em uma tela de mesas,
   * deixa o submenu aberto.
   */
  this.tablesMenuOpen =
    this.isTablesRouteActive;
}


closeTablesMenuOnMobile(): void {

  if (window.innerWidth <= 680) {
    this.tablesMenuOpen = false;
  }

}

  loadRestaurantContext(): void {
    const savedRestaurant =
      this.restaurantContext
        .getRestaurant();

    /*
     * Só reutiliza o restaurante salvo
     * quando ele possui uma role válida.
     */
    if (
      savedRestaurant?.id &&
      savedRestaurant?.role
    ) {
      console.log(
        'Restaurante recuperado do contexto:',
        savedRestaurant
      );

      this.loadingPermissions = false;
      this.permissionsLoaded = true;
      return;
    }

    this.api
      .get<any[]>('/restaurants')
      .subscribe({
        next: (restaurants) => {
          console.log(
            'Restaurantes retornados pela API:',
            restaurants
          );

          if (!restaurants.length) {
            this.loadingPermissions = false;
            this.permissionsLoaded = true;
            return;
          }

          const restaurant =
            restaurants[0];

          /*
           * Verifica se a API realmente
           * retornou a função do usuário.
           */
          if (!restaurant.role) {
            console.error(
              'O restaurante foi retornado sem a propriedade role:',
              restaurant
            );

            this.loadingPermissions = false;
            this.permissionsLoaded = true;
            return;
          }

          /*
           * Garante que valores como
           * "owner" ou "admin" sejam
           * convertidos para maiúsculo.
           */
          const normalizedRole =
            String(
              restaurant.role
            ).toUpperCase() as RestaurantRole;

          this.restaurantContext
            .setRestaurant({
              id: Number(
                restaurant.id
              ),
              name:
                restaurant.name,
              role:
                normalizedRole
            });

          console.log(
            'Restaurante salvo no contexto:',
            this.restaurantContext
              .getRestaurant()
          );

          this.loadingPermissions = false;
          this.permissionsLoaded = true;
        },
        error: (error) => {
          console.error(
            'Erro ao carregar os restaurantes:',
            error
          );

          this.loadingPermissions = false;
          this.permissionsLoaded = true;
        }
      });
  }

  can(
    permission: Permission
  ): boolean {
    const allowed =
      this.restaurantContext
        .hasPermission(permission);

    return allowed;
  }

  get role():
    RestaurantRole | null {
    return this.restaurantContext
      .getRole();
  }

  get roleLabel(): string {
    const labels:
      Record<
        RestaurantRole,
        string
      > = {
        OWNER: 'Proprietário',
        ADMIN: 'Administrador',
        ATTENDANT: 'Atendente',
        CASHIER: 'Caixa'
      };

    if (!this.role) {
      return '';
    }

    return labels[this.role];
  }

  get userName(): string {
    return (
      this.user?.name ||
      'Usuário'
    );
  }

  get userEmail(): string {
    return (
      this.user?.email ||
      ''
    );
  }

  get userInitial(): string {
    return this.userName
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  logout(): void {
    this.restaurantContext.clear();
    this.auth.logout();
  }
}